import { DEFAULT_LOCALE_UNDERSCORE, getFinalLocale } from '../src/lib/localeInfo';

type LocaleMessages = Record<string, string>;

function normalizeToUnderscoreLocale(locale?: string): string {
    // Global replace: multi-subtag locales (e.g. zh-Hant-TW) have more than one separator,
    // and a string-pattern replace only swaps the first, producing a malformed locale and a
    // wrong ./translations/*.json import path.
    return getFinalLocale(locale).replace(/-/g, '_');
}

/** BCP47-ish locale (dash) for react-intl, e.g. `en-US`. */
export function formatLocale(locale?: string): string {
    return normalizeToUnderscoreLocale(locale).replace(/_/g, '-');
}

/**
 * Load the translation catalog for a locale, falling back to en_US and then to an
 * empty catalog. trending ships no translations yet (en_US source strings), so this
 * returns {} — components then render their source/defaultMessage strings.
 */
export async function getLocaleMessages(locale?: string): Promise<LocaleMessages> {
    const normalized = normalizeToUnderscoreLocale(locale);
    try {
        const m = await import(`./translations/${normalized}.json`);
        return (m.default ?? m) as LocaleMessages;
    } catch {
        try {
            const f = await import(`./translations/${DEFAULT_LOCALE_UNDERSCORE}.json`);
            return (f.default ?? f) as LocaleMessages;
        } catch {
            return {};
        }
    }
}
